<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div class="venueStyle__pages__3golT undefined venueStyle__ty__3em5P" style="background-image: url(/static/image/bg.ad71d5e9d0a5ee6c91cc85f3664b5c43.jpg); height: 800px">
        <div class="venueStyle__content__37kNp" v-if="$store.state.sportList.length > 0">
          <div class="venueStyle__contentLeft__3bmvb" v-for="(item, index) in $store.state.sportList" :key="index" v-if="type == index">
            <img :src="`/static/image/sport/${item.platform_name}_sport_title.png`" width="449.2px" class="venueStyle__title__K3KhH" style="width: 450px; min-height: 124px;opacity: 1; margin-left: 0px" /><span class="venueStyle__subTitle__2nKwg"
              >倾力打造的刺激火爆的体育娱乐游戏，每天为您提供千场精彩体育赛事，多种娱乐方式选择，让您拥有完美游戏体验。
              <ul class="venueStyle__icons__kTABJ"></ul>
            </span>

                       <a id="gotogames" class="gotogames" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"><img src="/static/image/btn.1cfd2c8e17e20f1631dd11d7504e717d.png" width="176px" class="venueStyle__btn__HuPwB" style="margin-top: 25px; margin-left: -3px" /> </a>

          </div>
          <div class="venueStyle__models__zXaM0"><img :src="`/static/image/sport/${type}.png`" width="800px" class="" style="margin-left: -28px; opacity: 1" /></div>

          <ul class="venueStyle__tabs__3wTus" style="margin-left: -132px">
            <li class="venueStyle__tabItem__11CR_" v-for="(item, index) in $store.state.sportList" :key="index" @click="changType(index)">
             <img v-if="type == index" :src="`/static/image/sport/${item.platform_name}_sport_active.png`" width="180px" style="" />
              <img v-else :src="`/static/image/sport/${item.platform_name}_sport_inactive.png`" width="180px" style="" /> 
              </li>
          </ul>
          <img src="/static/image/anm-ob-1.e2d93640f3456429c6182d1aac07e3c8.png" width="124px" class="venueStyle__anm__3WJmq xf_img1" style="left: -108px; top: 606px" />
          <img src="/static/image/anm-ob-2.43bc2a0d8aa959e723f9f74fe387cf72.png" width="92px" class="venueStyle__anmTwo__1r2lK xf_img2" style="left: 1390px; top: 645px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sport',
  data() {
    return {
      type:0
    };
  },
  created() {
    let that = this;
  },
  methods: {
        changType(index) {
      let that = this;
      that.type = index;
    },
  },
  mounted() {
    let that = this;
    $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);
        $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
        $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  updated() {
    let that = this;
     $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);
        $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
        $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Lottery_793450d6.8907158d.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/sport.vue